import React, {Component} from 'react'
import PropTypes from 'prop-types';
import Tools from 'commonjs-tools/build/tools'

import './list-pagify.styl'

import Button from '../button/button'

import { firstPage, lastPage, nextPage, previousPage, morePages } from '../icon/icons';
import Icon from '../icon/icons/icon';

const {range} = Tools
// Object.defineProperty(this, 'printedPageCount', { value: 10, writable: false });
class ListPagify extends Component {
    static propTypes = {
        className: PropTypes.string,
        current: PropTypes.number,
        onClick: PropTypes.func.isRequired,
        elementByPage: PropTypes.number.isRequired,
        collectionCount: PropTypes.number.isRequired
    }

    static PRINTED_PAGES = 5

    previous(e){
        e.preventDefault();
        let { elementByPage, current } = this.props;
        this.props.onClick({page: current-1, count: elementByPage})
    }

    next(e){
        e.preventDefault();
        let { elementByPage, current } = this.props;
        this.props.onClick({page: current+1, count: elementByPage})
    }

    setPage(page) {
        return e => {
            e.preventDefault();
            let {elementByPage} = this.props;
            this.props.onClick({page, count: elementByPage});
        }
    }

    render() {
        const {collectionCount, elementByPage, current} = this.props;
        const count = Math.ceil(collectionCount / elementByPage);
        if(!collectionCount || count<2) {
            console.log('ListPagify count: ', count);
            console.log('ListPagify collectionCount: ', collectionCount);
            return ""
        }

        let {className=false} = this.props;
        className = className ? className  + ' list-pagify': 'list-pagify'

        const firstPreviousPage = (current - ListPagify.PRINTED_PAGES > 1) ? current - ListPagify.PRINTED_PAGES : 1;
        const lastPreviousPage = (firstPreviousPage + ListPagify.PRINTED_PAGES) <   current ?   current :   current - 1;
        const firstNextPage = ( current + 1 <= count) ?  current+1 : count + 1;
        const lastNextPage = (firstNextPage + ListPagify.PRINTED_PAGES) >  count ?  count :  firstNextPage + ListPagify.PRINTED_PAGES;

        const previousPages = firstPreviousPage <= lastPreviousPage ? range(firstPreviousPage, lastPreviousPage + 1) : [];
        const nextPages = firstNextPage <= lastNextPage ? range(firstNextPage, lastNextPage + 1) : [];

        // console.log('ListPagify current: ', current);
        // console.log('ListPagify count: ', count);
        // console.log('ListPagify collectionCount: ', collectionCount);
        // console.log('ListPagify elementByPage: ', elementByPage);
        // console.log('ListPagify firstPreviousPage : ', firstPreviousPage );
        // console.log('ListPagify lastPreviousPage : ', lastPreviousPage );
        // console.log('ListPagify firstNextPage : ', firstNextPage );
        // console.log('ListPagify lastNextPage : ', lastNextPage );

        const buttonPage = (svg, onClick) => <li><Button className="num" onClick={onClick} icon={svg} /></li>
        const pages = pages => pages.map((p, i) => <li key={i}><Button className="num" onClick={this.setPage(p)} label={p} /></li> )

        const hasFirstPage = current > ListPagify.PRINTED_PAGES;
        const hasPreviousPage = current > 0;
        const hasMorePreviousPage = previousPages[0] > 1;
        const hasMoreNextPage = current + nextPages.length < count-1;
        const hasNextPage = current + 1 <= count;
        const hasLastPage = current + ListPagify.PRINTED_PAGES <= count;

        return <ul className={className}>
            { hasFirstPage && buttonPage('firstPage', this.setPage(1)) }
            { hasPreviousPage && buttonPage('previousPage', e => this.previous(e)) }
            { hasMorePreviousPage && <li><Icon className="num" svg={morePages} /></li> }

            { pages(previousPages) }
            <li><div className="num-selected">{current}</div></li>
            { pages(nextPages)}

            { hasMoreNextPage && <li><Icon className="num" svg={morePages} /></li> }
            { hasNextPage && buttonPage('nextPage', e => this.next(e)) }
            { hasLastPage && buttonPage('lastPage', this.setPage(count)) }
        </ul>
    }
}

export default ListPagify
